import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EdlCommonPipesModule } from '@edl-development/edl-common';
import { UIRouterModule } from '@uirouter/angular';
import { PipesModule } from '../pipes/pipes.module';
import { SharedComplianceItemsModule } from '../shared-compliance-items/shared-compliance-items.module';
import { PrintRosterComponent } from './print-roster.component';
import { PrintStates } from './print.states';
import { QuestionnairePrintReportModule } from './questionnaires/questionnaire-print.module';
import { TimeTrackingPrintReportsModule } from './reports/time-tracking/time-tracking-print-reports.module';
import { PrintItemComponent } from './reports/item/print-item.component';
import { VolunteerPrintReportsModule } from './reports/volunteer/volunteer-print-reports.module';
import { ResolverModule } from '../resolvers/resolver.module';
import { EdlTimeTrackingModule } from '../time-tracking/time-tracking.module';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            states: PrintStates
        }),
        SharedComplianceItemsModule,
        TimeTrackingPrintReportsModule,
        QuestionnairePrintReportModule,
        EdlCommonPipesModule,
        PipesModule,
        VolunteerPrintReportsModule,
        ResolverModule,
        EdlTimeTrackingModule
    ],
    declarations: [
        PrintRosterComponent,
        PrintItemComponent
    ]
})
export class PrintModule { }